import React from 'react';
import './PaginationDiv.css';

const PaginationDiv = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <li key={i}>
          <button
            type="button"
            className={`page-number ${i === currentPage ? 'current' : ''}`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }
    return pages;
  };

  return (
    <div className="pagination-div">
      <ul className="pagination">
        <li>
          <button
            type="button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <i className="fas fa-chevron-left" aria-hidden="true" />
          </button>
        </li>
        {renderPageNumbers()}
        <li>
          <button
            type="button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <i className="fas fa-chevron-right" aria-hidden="true" />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationDiv;
